import { DEFAULT_GRID_SIZE } from 'libs/util/src/lib/constants/common.constants';
import {
  ACCEPT_HOO_REQUEST,
  ACCEPT_HOO_REQUEST_FAILURE,
  ACCEPT_HOO_REQUEST_SUCCESS,
  DELETE_HOO_REQUEST,
  DELETE_HOO_REQUEST_FAILURE,
  DELETE_HOO_REQUEST_SUCCESS,
  FETCH_LOCATIONS_FOR_REQUESTOR,
  FETCH_LOCATIONS_FOR_REQUESTOR_FAILURE,
  FETCH_LOCATIONS_FOR_REQUESTOR_SUCCESS,
  FETCH_REQUESTORS,
  FETCH_REQUESTORS_FAILURE,
  FETCH_REQUESTORS_SUCCESS,
  REJECT_HOO_REQUEST,
  REJECT_HOO_REQUEST_FAILURE,
  REJECT_HOO_REQUEST_SUCCESS,
  SAVE_HOO_REQUEST,
  SAVE_HOO_REQUEST_FAILED,
  SEARCH_HOO,
  SEARCH_HOO_FAILED,
  SEARCH_HOO_SUCCESS,
  SET_SEARCH_HOO,
} from './actions';

export const defaultSearchHooRequests = {
  page: 0,
  size: DEFAULT_GRID_SIZE,
  statuses: ['Pending'],
  isAllRecords: true,
};

type TState = {
  requests: [];
  loading: boolean;
  error: any;
  search: any;
  requestors: any[];
  locations: any[];
  allRequestorData: any[];
  loadingRequestors: boolean;
  loadingLocations: boolean;
  reasons: any[];
  hoursOptions: string[];
};

const initialState: TState = {
  requests: [],
  loading: false,
  reasons: [{ label: 'Other', value: 'Other' }],
  error: null,
  search: defaultSearchHooRequests,
  requestors: [],
  locations: [],
  allRequestorData: [],
  loadingRequestors: false,
  loadingLocations: false,
  hoursOptions: [
    '7:00 AM-4:00 PM',
    '7:00 AM-5:00 PM',
    '7:00 AM-6:00 PM',
    '8:00 AM-1:00 PM',
    '8:00 AM-2:00 PM',
    '8:00 AM-3:00 PM',
    '8:00 AM-4:00 PM',
    '8:00 AM-5:00 PM',
    '8:30 AM-5:00 PM',
    '8:30 AM-5:30 PM',
    '8:00 AM-6:00 PM',
    '8:00 AM-7:00 PM',
    '9:00 AM-3:00 PM',
    '9:00 AM-4:00 PM',
    '9:00 AM-5:00 PM',
    '9:00 AM-6:00 PM',
    '9:00 AM-7:00 PM',
    '9:00 AM-8:00 PM',
    '10:00 AM-5:00 PM',
    '10:00 AM-6:00 PM',
    '10:00 AM-7:00 PM',
    '10:00 AM-8:00 PM',
    '10:00 AM-9:00 PM',
    '11:00 AM-5:00 PM',
    '11:00 AM-7:00 PM',
    '11:00 AM-8:00 PM',
    '12:00 PM-5:00 PM',
    '12:00 PM-6:00 PM',
    'CLOSED',
  ],
};

export const hooAccomodationsReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case SET_SEARCH_HOO:
      return {
        ...state,
        search: { ...state.search, ...payload },
      };
    case SEARCH_HOO:
      return {
        ...state,
        loading: true,
      };
    case SEARCH_HOO_SUCCESS:
      return {
        ...state,
        loading: false,
        requests: payload.contents || [],
      };
    case SEARCH_HOO_FAILED:
      return {
        ...state,
        loading: false,
        error: payload,
        requests: [],
      };
    case FETCH_REQUESTORS:
      return { ...state, loadingRequestors: true, error: null };
    case FETCH_REQUESTORS_SUCCESS:
      return {
        ...state,
        loadingRequestors: false,
        requestors: payload.requestors,
        allRequestorData: payload.allData,
      };
    case FETCH_REQUESTORS_FAILURE:
      return { ...state, loadingRequestors: false, error: payload };
    case FETCH_LOCATIONS_FOR_REQUESTOR:
      return { ...state, loadingLocations: true, error: null };
    case FETCH_LOCATIONS_FOR_REQUESTOR_SUCCESS:
      return { ...state, loadingLocations: false, locations: payload };
    case FETCH_LOCATIONS_FOR_REQUESTOR_FAILURE:
      return { ...state, loadingLocations: false, error: payload };
    case DELETE_HOO_REQUEST:
      return { ...state, loading: true, error: null };
    case DELETE_HOO_REQUEST_SUCCESS:
      return { ...state, loading: false };
    case DELETE_HOO_REQUEST_FAILURE:
      return { ...state, loading: false, error: payload };
    case ACCEPT_HOO_REQUEST:
      return { ...state, loading: true, error: null };
    case ACCEPT_HOO_REQUEST_SUCCESS:
      return { ...state, loading: false };
    case ACCEPT_HOO_REQUEST_FAILURE:
      return { ...state, loading: false, error: payload };
    case REJECT_HOO_REQUEST:
      return { ...state, loading: true, error: null };
    case REJECT_HOO_REQUEST_SUCCESS:
      return { ...state, loading: false };
    case REJECT_HOO_REQUEST_FAILURE:
      return { ...state, loading: false, error: payload };
    case SAVE_HOO_REQUEST:
      return { ...state, loading: true, error: null };
    case SAVE_HOO_REQUEST_FAILED:
      return { ...state, loading: false };
    case SAVE_HOO_REQUEST_FAILED:
      return { ...state, loading: false, error: payload };
    default:
      return state;
  }
};
